import { Extension as e } from "@tiptap/core";
import { AllSelection as t, TextSelection as n } from "@tiptap/pm/state";
//#region src/extensions/indent-extension/indent.ts
function r(e, t, n) {
	return e < t ? t : e > n ? n : e;
}
var i = /* @__PURE__ */ function(e) {
	return e[e.min = 0] = "min", e[e.max = 140] = "max", e[e.more = 20] = "more", e[e.less = -20] = "less", e;
}({});
function a(e) {
	return e.type.name === "bullet_list";
}
function o(e) {
	return e.type.name === "order_list";
}
function s(e) {
	return a(e) || o(e);
}
function c(e, t, n) {
	if (!e.doc) return e;
	let i = e.doc.nodeAt(t);
	if (!i) return e;
	let a = 0;
	typeof i.attrs.indent == "number" ? a = i.attrs.indent : typeof i.attrs.indent == "string" && (a = parseInt(i.attrs.indent) || 0);
	let o = r(a + n, 0, 140);
	if (o === a) return e;
	let s = {
		...i.attrs,
		indent: o
	};
	return e.setNodeMarkup(t, i.type, s, i.marks);
}
function l(e, r) {
	let { doc: i, selection: a } = e;
	if (!i || !a || !(a instanceof n || a instanceof t)) return e;
	let { from: o, to: l } = a;
	return i.nodesBetween(o, l, (t, n) => {
		let i = t.type;
		return i.name === "paragraph" || i.name === "heading" ? (e = c(e, n, r), !1) : !s(t);
	}), e;
}
var u = e.create({
	name: "indent",
	addOptions() {
		return {
			types: ["heading", "paragraph"],
			indentLevels: [
				0,
				20,
				40,
				60,
				80,
				100,
				120,
				140
			],
			defaultIndentLevel: 0
		};
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { indent: {
				default: this.options.defaultIndentLevel,
				renderHTML: (e) => ({ style: `margin-left: ${typeof e.indent == "number" ? e.indent : parseInt(String(e.indent)) || this.options.defaultIndentLevel}px;` }),
				parseHTML: (e) => {
					let t = e.style.marginLeft, n = this.options.defaultIndentLevel;
					if (t && typeof t == "string") {
						let e = parseInt(t.replace(/[^\d.-]/g, ""));
						isNaN(e) || (n = e);
					}
					return n;
				}
			} }
		}];
	},
	addCommands() {
		return {
			indent: () => ({ tr: e, state: t, dispatch: n }) => {
				let { selection: r } = t;
				return e = e.setSelection(r), e = l(e, 20), e.docChanged ? (n && n(e), !0) : !1;
			},
			outdent: () => ({ tr: e, state: t, dispatch: n }) => {
				let { selection: r } = t;
				return e = e.setSelection(r), e = l(e, -20), e.docChanged ? (n && n(e), !0) : !1;
			}
		};
	}
});
//#endregion
export { u as Indent, i as IndentProps, r as clamp, a as isBulletListNode, s as isListNode, o as isOrderedListNode };
